export type LeaderboardRangeKey = 'report' | 'today' | '1d' | '7d' | '1mo' | '1y' | 'all'

export const toUtcYmd = (date: Date) => {
    const year = date.getUTCFullYear()
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const day = String(date.getUTCDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export const isUtcYmd = (value: unknown): value is string => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
    return toUtcYmd(new Date(`${value}T00:00:00Z`)) === value
}

export const addUtcDays = (ymd: string, days: number) => {
    const [year, month, day] = ymd.split('-').map(Number)
    const date = new Date(Date.UTC(year, month - 1, day))
    date.setUTCDate(date.getUTCDate() + days)
    return toUtcYmd(date)
}

export const formatUtcDateLabel = (ymd: string) => {
    const [year, month, day] = ymd.split('-').map(Number)
    return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
    })
}

export const computeLeaderboardRange = (
    range: LeaderboardRangeKey,
    { reportDate, now = new Date() }: { reportDate?: string; now?: Date } = {},
): { start_date?: string; end_date?: string } => {
    if (range === 'report') {
        return reportDate && isUtcYmd(reportDate)
            ? { start_date: reportDate, end_date: addUtcDays(reportDate, 1) }
            : {}
    }
    if (range === 'all') return {}

    // UTC midnight makes the shared leaderboard windows deterministic for all
    // viewers, independent of their local timezone.
    const startOfTodayUtc = new Date(now)
    startOfTodayUtc.setUTCHours(0, 0, 0, 0)
    const todayStr = toUtcYmd(startOfTodayUtc)

    if (range === 'today') return { start_date: todayStr }

    const startDate = new Date(startOfTodayUtc)
    if (range === '1d') {
        startDate.setUTCDate(startDate.getUTCDate() - 1)
    } else if (range === '7d') {
        startDate.setUTCDate(startDate.getUTCDate() - 7)
    } else if (range === '1mo') {
        startDate.setUTCMonth(startDate.getUTCMonth() - 1)
    } else if (range === '1y') {
        startDate.setUTCFullYear(startDate.getUTCFullYear() - 1)
    }

    return { start_date: toUtcYmd(startDate), end_date: todayStr }
}
